
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[jid]",
      function () {
        return require("private-next-pages/jobs/[jid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/[jid]"])
      });
    }
  